import 'react-app-polyfill/ie11';
import 'core-js/features/array/find';
import 'core-js/es';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker.js';
import Router from "./Router";
import {GlobalDataContextProvider} from "./contexts/GlobalDataContext";

ReactDOM.render(
    <GlobalDataContextProvider>
        <Router />
    </GlobalDataContextProvider>
    , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
